<template>
  <div class="home">
    <!-- <carousel></carousel> -->
    <div class="middle_module">
      <div class="home-middle">
        <articlequLeft></articlequLeft>
      </div>
      <div class="home-right">
        <HomeRight></HomeRight>
      </div>
    </div>
    <BackTop :height="80" :bottom="80">
      <div class="top">返回顶端</div>
    </BackTop>
  </div>
</template>

<script>
import articlequLeft from "@/components/article/articlequLeft.vue";
import HomeRight from "@/components/HomeRight.vue";

export default {
  name: "home",
  components: {
    HomeRight,
    articlequLeft
  }
};
</script>
<style scoped lang="scss">
.home {
  .top {
    padding: 10px;
    background: rgba(0, 210, 165, 0.6);
    color: #fff;
    text-align: center;
    border-radius: 2px;
  }
  .middle_module {
    margin: 0px auto;
    padding: 90px 0 20px 0;
    display: flex;
    flex-direction: row;
    width: 1200px;
    @media screen and(max-width:1200px) {
        width: 100%;
      }
    .home-middle {
      flex: auto;
      padding: 10px;
      background-color: #fff;
      border: 1px #f2f2f2 solid;
      box-shadow: 0 0 3px #ddd;
    }
    
    .home-right {
      @media screen and(max-width:1200px) {
        display: none;
      }
      width: 300px;
      margin-left: 1rem;
    }
  }
}
</style>
